import React from "react";
import { Table, Button } from "reactstrap";
import {
  countOrInteractiveButtonBasedOnFunction,
  countOrInteractiveHeaderBasedOnFunction
} from "../../../../utils/helperMethods";

export default class TablaFlia extends React.Component {
  render() {
    if (!this.props.data) return null;

    return (
      <Table hover className="mb-0">
        <thead>
          <tr>

            <th className="text-center">Apellido</th>
            <th className="text-center">Nombre</th>
            <th className="text-center">Mail</th>
            <th className="text-center">Provincia</th>
            <th className="text-center">Localidad</th>
            {countOrInteractiveHeaderBasedOnFunction(this.props.onView,"Usuarios")}

          </tr>
        </thead>
        <tbody>
          {this.props.data.map((e, index) => {
            return (
              <tr key={e.id}>

                <td className="text-center">{e.apellido}</td>
                <td className="text-center">{e.nombre}</td>
                <td className="text-center">{e.usuario}</td>
                <td className="text-center">{e.localidad.provincia.nombre}</td>
                <td className="text-center">{e.localidad.nombre}</td>
                {countOrInteractiveButtonBasedOnFunction(this.props.onView,e,"Usuarios",e.countUsuarios)}

              </tr>
            );
          })}
          <div>
            <nav
              aria-label="Page"
              className="d-flex w-100 justify-content-center  "
            >
              <ul className="pagination">
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(0)}
                >
                  <a className="page-link" aria-label="Previous">
                    <span aria-hidden="true">«</span>
                    <span className="sr-only"> Pagina Anterior</span>
                  </a>
                </li>
                <li className="page-item">
                  <a className="page-link">{this.props.page}</a>
                </li>
                <li
                  className="page-item"
                  onClick={() => this.props.paginate(1)}
                >
                  <a className="page-link" aria-label="Next">
                    <span aria-hidden="true">»</span>
                    <span className="sr-only">Proxima Pagina</span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </tbody>
      </Table>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/Familia/component/TableHover.js